var lib_core = require("lib-core");

var SelectionGridInteractionModel = require("./selectionGridInteractionModel.js");
var SelectionGridInteractionView = require("./selectionGridInteractionView.js");
var AbstractInteractionModel = lib_core.AbstractInteractionModel;
var PathInteractionModel = require("../svg/pathViewer/pathInteractionModel.js");

var SelectionGridModel = function (editorModel, options, editorView) {
    var self = this;

    lib_core.Model.apply(this, arguments);

    this.editorModel = editorModel;
    this.selectionModel = this.editorModel.selectionModel();

    this.elements = this.set("elements", false);
    this.activeIM = this.value("activeIM", true); // this will be a reference to a model

    // to create new views
    this.editorView = editorView;
    this.options = options;

    this.selectionModel.selection.onAdd("selectionGridModel", function () {
        self.editorModel.heavyHandler.scheduleHeavy('update_model', self.update, self, [], self);
    }, 10);
    this.selectionModel.selection.onRemove("selectionGridModel", function () {
        self.editorModel.heavyHandler.scheduleHeavy('update_model', self.update, self, [], self);
    }, 10);
};
lib_core.inherit(SelectionGridModel, lib_core.Model);
lib_core.JsonParser.registerClass(SelectionGridModel, "SelectionGridModel");

module.exports = SelectionGridModel;

SelectionGridModel.prototype.update = function () {
    var self = this;

    // get all the elements that are grid selectable
    this.elements.removeAll();
    this.selectionModel.selection.forEach(function (selected) {
        if (selected.isGridSelectable) self.elements.add(selected);
    });

    if(this.elements.size() > 1) {
        this.selectionModel.selection.forEach(function (objIntModel, idx) {
            if(objIntModel.setFocus) {
                objIntModel.setFocus(false);
            }
            if(objIntModel.unhighlightAll) {
                objIntModel.unhighlightAll();
            }
        });
        if(this.activeIM() === null) this.createIM();
    }
};

/**
 * Instantiate interaction model, and interaction view
*/
SelectionGridModel.prototype.createIM = function () {
    this.activeIM(new SelectionGridInteractionModel(this, this.editorModel));

    var view = new SelectionGridInteractionView(    //TODO: model creating views!?
        this.editorView,
        this.activeIM(),
        this.editorView.rootGroup,
        this.options.layers);

    this.activeIM().onDie({}, function(o){
        view.removeSvg();
    },101);
};
